import React from "react";

const Sidebar = () => {
  const posts = [
    {
      title: "How Effective Is Finasteride for Hair Loss? Your Essential Guide Before Starting Treatment.",
      link: "/blogs/1/How-Effective-Is-Finasteride-for-Hair-Loss"
    },
    {
      title: "The Truth About Weight Loss Pills: Myths, Facts, and What You Should Know.",
      link: "/blogs/2/The-Truth-About-Weight-Loss-Pills"
    }
  ];

  return (
    <aside className="sidebar space-y-6 p-4 border rounded-lg shadow-md">
      <div>
        <h3 className="text-lg font-bold border-b pb-1 mb-2 text-green-700">
          Recent Posts
        </h3>
        <ul className="text-sm text-gray-700 space-y-2">
          {posts.map((post, index) => (
            <li key={index} className="flex items-start gap-2">
              <span className="text-[#064ACB] font-bold">&gt;</span>
              <a href={post.link} className="hover:underline text-[#064ACB]">{post.title}</a>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
